export default __webpack_public_path__ + "static/media/2d.d2d965ac.jpg";